import { DatePipe } from '@angular/common';
import AppValues from 'src/app/common/app.values';
import ProjectLinks from 'src/app/common/project.links';
import { UserInfo } from 'src/app/interfaces';
import { TableCellAttribute, TableHeadData, TableRowData } from 'src/app/interfaces/tables.interfaces';
import {
  Community,
  PendingUserInvolvement,
  PendingUserInvolvementInCommunity,
  Project,
  UserBasic,
} from 'src/app/swagger-api';
import { PendingUserInvolvementInProject } from '../../swagger-api';

export const userTableCellAttribute: TableCellAttribute[] = [{ value_class_front: 'userBasic', key: 'user' }];

export const membersTableCellAttributes: TableCellAttribute[] = [{ value_class_front: 'userBasic', key: 'user' }];

export const membersManageTableCellAttributes: TableCellAttribute[] = [
  ...membersTableCellAttributes,
  { value_class_front: 'remove', key: 'remove' },
];

export const userInfosManageTableCellAttributes: TableCellAttribute[] = [
  { value_class_front: 'userInfo', key: 'userInfo' },
  { value_class_front: 'remove', key: 'remove' },
];

export const noManageRequestsVsInvitesTableCellAttributes: TableCellAttribute[] = [
  { value_class_front: 'userBasic', key: 'user' },
  { value_class_front: 'date', key: 'created' },
];

export const manageRequestsVsInvitesTableCellAttributes: TableCellAttribute[] = [
  ...noManageRequestsVsInvitesTableCellAttributes,
  { value_class_front: 'manage', key: 'manage' },
];

export const removeRequestsVsInvitesTableCellAttributes: TableCellAttribute[] = [
  ...noManageRequestsVsInvitesTableCellAttributes,
  { value_class_front: 'remove', key: 'remove' },
];

export const userRequestsVsInvitesTableCellAttributes: TableCellAttribute[] = [
  { value_class_front: 'linkProfile', key: 'entity' },
  { value_class_front: 'date', key: 'created' },
];

export const userRequestsTableCellAttributes: TableCellAttribute[] = [
  ...userRequestsVsInvitesTableCellAttributes,
  { value_class_front: 'remove', key: 'remove' },
];

export const userInvitesTableCellAttributes: TableCellAttribute[] = [
  ...userRequestsVsInvitesTableCellAttributes,
  { value_class_front: 'manage', key: 'manage' },
];

export const connectionsRequestsTableCellAttributes: TableCellAttribute[] = [
  { value_class_front: 'userBasic', key: 'user' },
  { value_class_front: 'date', key: 'created' },
  { value_class_front: 'remove', key: 'remove' },
];

export const connectionsInvitesManageTableCellAttributes: TableCellAttribute[] = [
  ...userTableCellAttribute,
  { value_class_front: 'date', key: 'created' },
  { value_class_front: 'manage', key: 'manage' },
];

export const defaultMemberTableHead: TableHeadData[] = [{ text: 'TABLE_HEAD_USER' }];

export const defaultTableHead: TableHeadData[] = [{ text: 'TABLE_HEAD_USER' }, { text: 'TABLE_HEAD_DATE' }];

export const manageMemberTableHead: TableHeadData[] = [...defaultMemberTableHead, { text: 'TABLE_HEAD_MANAGE' }];

export const manageTableHead: TableHeadData[] = [...defaultTableHead, { text: 'TABLE_HEAD_MANAGE' }];

export const defaultCommunityTableHead: TableHeadData[] = [
  { text: 'TABLE_HEAD_COMMUNITY' },
  { text: 'TABLE_HEAD_DATE' },
];

export const defaultProjectTableHead: TableHeadData[] = [{ text: 'TABLE_HEAD_PROJECT' }, { text: 'TABLE_HEAD_DATE' }];

export const manageCommunityTableHead: TableHeadData[] = [...defaultCommunityTableHead, { text: 'TABLE_HEAD_MANAGE' }];

export const manageProjectTableHead: TableHeadData[] = [...defaultProjectTableHead, { text: 'TABLE_HEAD_MANAGE' }];

export const manageConnectionsInvitesTableHead: TableHeadData[] = [
  ...defaultMemberTableHead,
  { text: 'TABLE_HEAD_MANAGE' },
];

export const sharedEntityTableRowData: (
  request: PendingUserInvolvement,
  id: number,
  entityId: string,
  isInvite?: boolean,
) => TableRowData = (request: PendingUserInvolvement, id: number, entityId: string, isInvite = true) => {
  return {
    id: id + 1,
    entityId,
    actorId: request.user.user_id,
    user: request.user,
    manage: isInvite ? null : { status: null, reason: null },
    created: new DatePipe('en-US').transform(request.creation_date, AppValues.DATE_FORMAT_SHORT) ?? '',
  };
};

export const manageUsersTableRowData: (id: number, user: UserBasic, entity?: Community | Project) => TableRowData = (
  id: number,
  user: UserBasic,
  entity?: Community | Project,
) => {
  return {
    id: id + 1,
    actorId: user.user_id,
    entityId: entity ? entity.entity_id : '',
    user,
  };
};

export const manageUserInfosTableRowData: (id: number, user: UserInfo) => TableRowData = (
  id: number,
  userInfo: UserInfo,
) => {
  return {
    id: id + 1,
    actorId: userInfo.userId,
    entityId: '',
    userInfo,
  };
};

export const personalUserXRowData: (
  id: number,
  request: PendingUserInvolvementInCommunity,
  actorId: string,
  isInvite: boolean,
) => TableRowData = (id: number, request: PendingUserInvolvementInCommunity, actorId: string, isInvite: boolean) => {
  return {
    id: id + 1,
    entityId: request.community.entity_id,
    actorId,
    entity: request.community,
    link: `${request.community.focus === 'CHARITY' ? ProjectLinks.LINK_CHARITY_VIEW : ProjectLinks.LINK_COMMUNITY_VIEW}/`,
    title: request.community.title,
    manage: isInvite ? { status: null, reason: null } : null,
    created: new DatePipe('en-US').transform(request.creation_date, AppValues.DATE_FORMAT_SHORT) ?? '',
  };
};

export const personalUserProjectXRowData: (
  id: number,
  request: PendingUserInvolvementInProject,
  actorId: string,
  isInvite: boolean,
) => TableRowData = (id: number, request: PendingUserInvolvementInProject, actorId: string, isInvite: boolean) => {
  return {
    id: id + 1,
    entityId: request.project.entity_id,
    actorId,
    entity: request.project,
    link: `${ProjectLinks.LINK_PROJECTS_VIEW}/`,
    title: request.project.title,
    manage: isInvite ? { status: null, reason: null } : null,
    created: new DatePipe('en-US').transform(request.creation_date, AppValues.DATE_FORMAT_SHORT) ?? '',
  };
};
